import request from "../plugins/axios";

/**
 * 课程
 */
//  课程列表
export function courseList(params) {
	return request({
		url: '/scrm/getEmployeeCourse',
		method: 'GET',
		params
	})
}

// 课程下章节列表
export function courseLessonList(params) {
	return request({
		url: '/scrm/getCourseLessonList',
		method: 'GET',
		params
	})
}

// 创建课程分享链接
export function createCourseSharingLink(data) {
	return request({
		url: '/scrm/CreateCourseSharingLink',
		method: 'POST',
		data
	})
}

// 课程详情
export function lessonDetails(params) {
	return request({
		url: '/scrm/getLessonDetails',
		method: 'GET',
		params
	})
}

// 课程详情
export function trainLessonDataStatistics(params) {
	return request({
		url: '/scrm/TrainLessonDataStatistics',
		method: 'POST',
		params
	})
}

// 课程详情
export function trainLessonJoinLogList(params) {
	return request({
		url: '/scrm/TrainLessonJoinLogList',
		method: 'GET',
		params
	})
}


// 群管一键补发红包
export function ScrmOneKeyRedEnvelope(data) {
    return request({
        url: '/scrm/ScrmOneKeyRedEnvelope',
        method: 'POST',
        data
    })
}
// 群管一键补发积分
export function ScrmOneKeyResendIntegrate(data) {
    return request({
        url: '/scrm/ScrmOneKeyResendIntegrate',
        method: 'POST',
        data
    })
}
//群管一键完播
export function ScrmOneKeyComplete(data) {
    return request({
        url: '/scrm/ScrmOneKeyComplete',
        method: 'POST',
        data
    })
}


//群管端-经销商课程数据导出数据统计
export function ScrmQunguanExportTrainLessonStatistics(data) {
    return request({
        url: '/scrm/ScrmQunguanExportTrainLessonStatistics',
        method: 'POST',
        data
    })
}

// 更新课程详情
export function updateLessonDetails(data) {
    return request({
        url: '/scrm/updateTrainLesson',
        method: 'POST',
        data
    })
}
export function updateTrainLessonYmdRedMoney(data) {
    return request({
        url: '/scrm/updateTrainLessonYmdRedMoney',
        method: 'POST',
        data
    })
}


